<ion-header>
  <ion-toolbar class="header-color">
      <ion-buttons slot="start">
          <ion-back-button defaultHref="search/promotions"></ion-back-button>
        </ion-buttons>
    <ion-title>Booking Confirmed</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="center m-auto mt4" *ngIf="promotionDetails.class">
          <ion-icon name="checkmark-circle" class="checkMark"></ion-icon>
          <h3 class="title">{{promotionDetails?.class.title | titlecase }} with {{promotionDetails?.class.instructor.first_name}} {{promotionDetails?.class.instructor.last_name}}</h3>
          <p class="confirmation">Pass Confirmed!</p>
          <p class="confirmMail" *ngIf="emailId">A confirmation email has been sent to {{emailId}}.</p>
          <br />
          <ion-button fill='outline'  routerLink="/reservations" class="reservationBtn">My Reservations</ion-button>
          <br />
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="bgColor">
    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="center m-auto">
            <p class="connectFriends">Know any friends who'd love to join you?</p>
            <div class="socialBtns" *ngIf="promotionDetails?.class">
              <ion-button (click)="shareFacebook()" target="_blank"class="fbBtn"><ion-icon name="logo-facebook" slot="start"></ion-icon>Share on facebook</ion-button>
              <ion-button href="{{twitterShareUrl}}" target="_blank" class="twitterBtn"><ion-icon name="logo-twitter" slot="start"></ion-icon>Share on Twitter</ion-button>
              <ion-button href="mailto:?subject=Check out this activity on Promoga: {{promotionDetails?.class.title | titlecase}}&body={{emailBody}}" target="_blank" class="emailBtn"><ion-icon name="mail-outline" slot="start"></ion-icon>Share via Email</ion-button>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
